import React from 'react'
import { EventReqDtos } from '../../../api/interfaces/LeadsDto'
import ReadMore from './ReadMore'
import ReadMores from './ReadMores'
interface infoData {
    submittedData:any
  }
const EventInfoDetails:React.FC<infoData>=({submittedData})=> {
  return (
   
      <>
      {submittedData?.eventReqDtos && submittedData?.eventReqDtos?.length > 0  &&
        <div className='bg-white p-8 mt-8'>
                                            {/* <p className="border-b-2 border-gray-200"></p> */}
                                            <div className="">
                                              <p className="text-primary-color font-semibold text-2xl border-b pb-4 border-b-gray-200">
                                                Events
                                              </p>
                                              <div className="grid grid-cols-1 gap-10 pt-8 pb-12">
                                              {submittedData?.eventReqDtos?.map((item:EventReqDtos, index:number) => (
                                                <div className='flex gap-6 w-full'>
                                                  <div>
                                                   <img src={item?.imageDto?.documentUrl ||'/images/dummpComapnyLogo.svg'} className="h-[250px] w-[400px] rounded-[4px] pr-4 object-cover" />
                                                    </div>
                                                   <div className='w-full'>
                                                   <div className='flex items-center'>
                                                      {item?.name &&
                                                        <h3 className='text-black font-semibold text-xl mr-3'>{item?.name}</h3>
                                                      }
                                                      {item?.type === 'VIRTUAL' &&<span className='bg-[#FFF3F3] rounded-2xl text-[#B00A2B] px-3  font-semibold text-sm py-1'>Remote</span>}
                                                      </div>
                                                      {/* {item?.eventDetails &&
                                                      <div className="mt-3 text-sm">
        <ReadMore text={item?.eventDetails || ''} lines={6} />
      </div>} */}
                                                      <div className='flex space-x-8 py-4'>
                                                    
                                                    {item?.startDate && <div>
                                                      <h2 className='text-gray-700 font-normal text-sm'>
                                                      Start Date
                                                      </h2>
                                                      <p className="font-semibold text-base text-gray-900 pt-1">
                                                        {item?.startDate || 'NA'}
                                                      </p>
                                                      </div>}
                                                      {item?.endDate &&
                                                      <div>
                                                      <h2 className='text-gray-700 font-normal text-sm'>
                                                      End Date
                                                      </h2>
                                                      <p className="font-semibold text-base text-gray-900 pt-1">
                                                        {item?.endDate || 'NA'}
                                                      </p>
                                                      </div>}
                                                      </div>
                                                      <div className='grid grid-cols-3 gap-4'>
                                                {item?.contactPersonName &&
                                                  <div>
                                                      <h2 className='text-gray-700 font-normal text-sm break-words'>
                                                      Contact Person Name
                                                      </h2>
                                                      <p className="font-semibold text-base text-gray-900 pt-1 break-words">
                                                        {item?.contactPersonName || 'NA'}
                                                      </p>
                                                      </div>}
                                                      {item?.link &&
                                                      <div>
                                                      <h2 className='text-gray-700 font-normal text-sm'>
                                                      Event Link
                                                      </h2>
                                                      <p className="font-semibold text-base text-gray-900 pt-1 break-words">
                                                        {item?.link || 'NA'}
                                                      </p>
                                                      </div>}
                                                      {item?.phoneNo &&
                                                      <div>
                                                      <h2 className='text-gray-700 font-normal text-sm'>
                                                      Phone Number
                                                      </h2>
                                                      <p className="font-semibold text-base text-gray-900 pt-1 break-words">
                                                        {item?.phoneNo ||'NA'}
                                                      </p>
                                                      </div>}
                                                      {item?.contactPersonEmail &&
                                                      <div>
                                                      <h2 className='text-gray-700 font-normal text-sm break-words'>
                                                      Contact Person Email
                                                      </h2>
                                                      <p className="font-semibold text-base text-gray-900 pt-1">
                                                        {item?.contactPersonEmail || 'NA'}
                                                      </p>
                                                      </div>}
                                                      {item?.mtCountryDto?.name &&
                                                      <div>
                                                      <h2 className='text-gray-700 font-normal text-sm'>
                                                      Event Country
                                                      </h2>
                                                      <p className="font-semibold text-base text-gray-900 pt-1">
                                                        {item?.mtCountryDto?.name || 'NA'}
                                                      </p>
                                                      </div>}
                                                      {item?.venue &&
                                                      <div>
                                                      <h2 className='text-gray-700 font-normal text-sm'>
                                                      Event Venue
                                                      </h2>
                                                      <p className="font-semibold text-base text-gray-900 pt-1 break-words">
                                                        {item?.venue || 'NA'}
                                                      </p>
                                                      </div>}
                                                    </div>
                                                    <div className='grid grid-cols-1 mt-4'>
                                            {item?.eventDetails &&
                                               <div>
                                                                                                    <h2 className='text-gray-700 font-normal text-sm'>
                                                                                                    Event Details
                                                                                                    </h2>
                                                                                                    
                                                                                                    <p className="font-semibold text-base text-gray-900 pt-1 break-words">
                                                                                                    <ReadMores text={item?.eventDetails || 'NA'} lines={6} />
                                                                                                    </p>
                                                                                                    </div>}
                                              </div>
                                                    </div>
                                                  </div>
                                              ))}
                                              </div>
                                              
                                              </div></div>}</>

  )
}

export default EventInfoDetails
